import React from 'react';
import { Tag } from '~/shared/types/tag';
import { getLcn } from '~/utils/labeled-classnames';
import tagCategoryColors from '../../data/tagCategoryColors';

export default function TagPill({
  tag,
  count,
  onClick,
}: {
  tag: Tag,
  count?: number,
  onClick?: () => void
}) {
  const lcn = getLcn({
    tagPill: [
      'text-sm rounded-lg px-3 py-1 text-white white-space-nowrap',
      onClick ? 'cursor-pointer' : 'cursor-default'
    ]
  });
  const backgroundColor = tagCategoryColors[tag.tag_category_id] || '#000000';

  return (
    <button className={lcn.tagPill} style={{ backgroundColor }} onClick={onClick}>
      {tag.name}
      {count !== undefined && ` (${count})`}
    </button>
  );
}; 